import { Box, Tab } from "@mui/material";
import { TabPanel, TabContext, TabList } from "@mui/lab";
import { useEffect, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";

export const theme = createTheme({
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            color: "#b45309",
            fontWeight: "bold",
            backgroundColor: "#fde68a",
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: "#b45309",
        },
      },
    },
  },
});

export default function CategoryWrapper(props: any) {
  const { MainModel, BoxContent, staticCategories } = props;

  const [value, setValue] = useState("0");
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    MainModel.fetchCategories().then((response: any) => {
      setCategories(response.data);
    });
  }, []);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <ThemeProvider theme={theme}>
      <div className="pt-[67px] max-w-[1400px] mx-auto my-0 px-4 md:px-10 flex items-center justify-between">
        <Box sx={{ width: "100%", typography: "body1" }}>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleChange}
                aria-label="lab API tabs example"
                className="bg-[#fffbeb]"
              >
                {categories.map((category: any, index) => {
                  return (
                    <Tab
                      label={category.cname}
                      key={category.cpk}
                      value={index.toString()}
                      className="!text-[11px] sm:!text-sm"
                    />
                  );
                })}
              </TabList>
            </Box>
            <>
              {categories.map((category: any, index) => {
                return (
                  <TabPanel value={index.toString()} className="!px-0 !py-6">
                    <BoxContent category={category.cpk} />
                  </TabPanel>
                );
              })}
            </>
          </TabContext>
        </Box>
      </div>
    </ThemeProvider>
  );
}
